var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinJatMed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.109987 15.1249V4.47794H3.30499V15.1249H0.109987ZM12.897 15.1249V9.31994C12.897 8.12794 12.553 6.93694 11.152 6.93694C9.74999 6.93694 8.63299 8.12694 8.63299 9.34894V15.1269H5.42599V4.44394H8.63299V5.92494C9.61599 4.67394 11.004 4.10894 12.554 4.10894C14.104 4.10894 16.094 4.88294 16.094 9.08094V15.1259H12.897V15.1249ZM1.69299 3.41294C0.808987 3.41294 0.0929871 2.69694 0.0929871 1.81594C0.0929871 0.931943 0.808987 0.215942 1.69299 0.215942C2.57599 0.215942 3.29099 0.931943 3.29099 1.81594C3.29099 2.69694 2.57499 3.41294 1.69299 3.41294Z",
    fill: "#32976B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinJatMed);
export default __webpack_public_path__ + "static/media/linkedin_jat-med.6ee62922691b1a4ce744a00e4993ed96.svg";
export { ForwardRef as ReactComponent };